import { atom } from 'jotai';

export const installAppStateAtom = atom<{
  bipEvent: BeforeInstallPromptEvent | null;
  installAttempted: boolean;
}>({ bipEvent: null, installAttempted: false });

export const showInstallAppButtonAtom = atom((get) => {
  const { bipEvent, installAttempted } = get(installAppStateAtom);
  return bipEvent && !installAttempted;
});
